import React from 'react';
import './otto.css';

// Dust puff at Otto's feet — the prototype's shared #p-dust prop, geometry
// intact. Mounted for the duration of whichever shot needs it; `delay` places
// the puff on that shot's own clock (sneeze 0.95s, lean 2.66s) so it can't
// drift against the frame it belongs to.
export default function OttoDust({ delay = '0s' }) {
  return (
    <span className="otto-dust" aria-hidden="true" style={{ '--otto-dust-delay': delay }}>
      <svg viewBox="0 0 64 22">
        <ellipse cx="14" cy="17" rx="9" ry="5" fill="#C6CDB8" />
        <ellipse cx="32" cy="14" rx="11" ry="6" fill="#CFD5C2" />
        <ellipse cx="50" cy="17" rx="8" ry="4.5" fill="#C6CDB8" />
      </svg>
    </span>
  );
}
